export default __webpack_public_path__ + "static/media/logo-quadrant-blanco.7692c4fb.png";